import type { AppVueRouter } from '@modules/core/services/router/types';
import {
  ADMIN_BALANCES_ROUTE_NAME,
  BALANCES_PERMISSIONS,
} from '@modules/balances/constants';
import { AppModule } from '@modules/core/plugins/AppModule';

import {
  ADMIN_BALANCES_EDIT_ROUTE_NAME,
} from './constants';

export class BalancesEditModule extends AppModule {
  addRoutes(router: AppVueRouter): void {
    router.addChildRoute(ADMIN_BALANCES_ROUTE_NAME, {
      name: ADMIN_BALANCES_EDIT_ROUTE_NAME,
      path: 'adjustment/:id',
      component: () => import('./pages/BalancesEditPage/BalancesEditPage.vue'),
      permission: BALANCES_PERMISSIONS.EDIT,
    });
  }

  addMenu(): void {}

  addTranslationKeys(): void {}
}
